import { RenameIcon, TagIcon, TrashIcon } from "@/frontend/shared/assets/icons";
import { Typography } from "@/frontend/shared/ui/Typography";
import clsx from "clsx";

export function buildDropshadowOptions({
  onClickRename,
  onClickDelete,
  styles,
  hasItems
}: {
  styles: Record<string, string>;
  onClickRename: () => void;
  onClickDelete: () => void;
  hasItems: boolean;
}) {
  return [
    <div key="rename" className={clsx(styles.dropshadowOption, styles.dropshadowOptionActive)} onClick={onClickRename}>
      <RenameIcon />
      <Typography variant="label-4" color="greyscale800">
        Rename
      </Typography>
    </div>,
    <div
      key="export"
      className={clsx(styles.dropshadowOption, !hasItems && styles.dropshadowOptionActive)}
      onClick={hasItems ? () => null : onClickDelete}
    >
      <div className={clsx(styles.trashIconContainer, hasItems ? styles.disabledIcon : styles.enabledIcon)}>
        <TrashIcon />
      </div>
      <div>
        <Typography variant="label-4" color={hasItems ? "greyscale400" : "greyscale900"}>
          Delete
        </Typography>
        {/* {hasItems && ( */}
        <Typography variant="body-3" color={hasItems ? "greyscale400" : "greyscale700"}>
          Stage must be empty to delete
        </Typography>
        {/* // )} */}
      </div>
    </div>
  ];
}
